<template>
    <div v-if="totalPages > 1" class="pageNav">
        <div id="btnPrevious" :class="{ disabled: page === 1 }" class="previous" @click="previousPage"></div>
        <div class="pageText" style="padding-left: 10px; padding-right: 10px">
            {{ pageXOfYString }}
        </div>
        <div id="btnNext" :class="{ disabled: page >= totalPages }" class="next" @click="nextPage"></div>
    </div>
</template>

<script>
    export default {
        name: 'CicPageControl',
        props: {
            page: {
                type: Number,
                required: true,
            },
            // The total number of rows in the result set.
            // Even if you only want to display the first x, this should be the full count.
            totalRows: {
                type: Number,
                required: true,
            },
            resultsPerPage: {
                type: Number,
                default: 20,
            },
        },
        emits: ['change'],
        computed: {
            totalPages() {
                if (this.totalRows === 0) {
                    return 1;
                }

                return Math.ceil(this.totalRows / this.resultsPerPage);
            },
            pageXOfYString() {
                return this.$t('Page [a] of [b]').replace('[a]', this.page).replace('[b]', this.totalPages);
            },
        },
        methods: {
            // go to next page in paginated table
            nextPage() {
                if (this.page < this.totalPages) {
                    this.$emit('change', this.page + 1);
                }
            },
            // go to previous page in paginated table
            previousPage() {
                if (this.page - 1 > 0) {
                    this.$emit('change', this.page - 1);
                }
            },
        },
    };
</script>
